import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { AppValidators } from 'src/app/common/appValidators';
import { FilterTypesEnum } from 'src/app/models/filters/filterTypes.enum';
import { AiActivityFiltersModel } from 'src/app/models/filters/implementations/pageFilters/aiActivityFilters.model';
import { ISelectOption } from 'src/app/models/selectOptions';
import { FeatureFlagsService } from 'src/app/services/infra/featureFlags/feature-flags.service';
import { DateTime } from 'luxon';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-ai-activity-filters',
  templateUrl: './ai-activity-filters.component.html',
  styleUrls: ['./ai-activity-filters.component.scss'],
})
export class AiActivityFiltersComponent implements OnInit {
  @Input() public pageFilters: AiActivityFiltersModel;

  public clearCustomViewSelection$ = new BehaviorSubject(undefined);

  public selectedOptions: ISelectOption[] = [];

  public searchBoxNewValue = new ReplaySubject<string | undefined>(1);
  public fromDateNewValue = new ReplaySubject<Date | undefined>(1);
  public toDateNewValue = new ReplaySubject<Date | undefined>(1);
  public searchValidators = [AppValidators.evenNumberOfQuoteMarks];
  public minDate = DateTime.now().minus({ months: 3 }).toJSDate();

  private _customViewTriggered = false;

  constructor(
    public featureFlagService: FeatureFlagsService,
    private readonly _destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.pageFilters.onUpdate$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((data) => {
      this.selectedOptions = this.pageFilters.getAllSelectedOptions();

      this.searchBoxNewValue.next(data.search);
      this.fromDateNewValue.next(data.fromDate);
      this.toDateNewValue.next(data.toDate);

      if (this._customViewTriggered) {
        this._customViewTriggered = false;
      } else {
        this.clearCustomViewSelection$.next(undefined);
      }
    });
  }

  public fromDateSelected(value?: Date): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.FromDate, value);
  }

  public toDateSelected(value?: Date): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.ToDate, value);
  }

  public searchSubmitted(value?: string): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.Search, value);
  }
}
